import { atom } from 'jotai';

/** 정렬을 고를 수 있는 쿠폰 탭 */
export type CouponSortTab = 'MY' | 'DOWNLOAD' | 'HISTORY';

export type CouponSort = 'registered' | 'closingSoon';

/** 탭별 쿠폰 정렬. CouponSortBottomSheet 에서 선택한 값을 목록으로 전달한다. */
export const couponSortsAtom = atom<Record<CouponSortTab, CouponSort>>({
    MY: 'registered',
    DOWNLOAD: 'registered',
    HISTORY: 'registered',
});
